import * as React from 'react';
import { useEffect } from 'react';

import { SpinnerSvg } from './spinner';

interface SmartSpinnerProps {
  onMount?: () => void;
  message?: string;
}

export const SmartSpinner: React.FC<SmartSpinnerProps> = ({ onMount, message }) => {
  useEffect(() => {
    if (onMount) {
      onMount();
    }
  }, [onMount]);

  return (
    <div className="loading-spinner">
      <div className="spinner-container">
        <SpinnerSvg />
        <p className="spinner-message">{message}</p>
      </div>
    </div>
  );
};
